import { StaticImageData } from 'next/image'

import {
  DougImage,
  JohnImage,
  RachelImage,
} from 'Assets/Images/Sections/HomeHeroSection'

type HeroAvatarItem = {
  id: string
  image: StaticImageData
  imageAlt: string
}

export const HERO_AVATARS_ITEMS: HeroAvatarItem[] = [
  {
    id: 'HeroAvatarItem-001',
    image: JohnImage,
    imageAlt: '',
  },
  {
    id: 'HeroAvatarItem-002',
    image: DougImage,
    imageAlt: '',
  },
  {
    id: 'HeroAvatarItem-003',
    image: RachelImage,
    imageAlt: '',
  },
]
